import { Area } from '../areaDesigner.model';
import { AreaDesignerManager } from '../areaDesignerManager';
import AreaDesignerPlugin from './areaDesignerPlugin';

export class AreaDesignerAreaSizePlugin implements AreaDesignerPlugin {
    private manager!: AreaDesignerManager;

    private layer!: paper.Layer;
    private widthLabel!: paper.Group;
    private heightLabel!: paper.Group;

    public create = (manager: AreaDesignerManager) => {
        this.manager = manager;

        this.layer = new manager.paper.Layer();
        this.layer.name = 'area-size-labels';
        this.layer.bringToFront();

        this.widthLabel = new manager.paper.Group();
        this.widthLabel.applyMatrix = false;
        this.layer.addChild(this.widthLabel);

        this.heightLabel = new manager.paper.Group();
        this.heightLabel.applyMatrix = false;
        this.layer.addChild(this.heightLabel);

        this.createLabel(this.widthLabel);
        this.createLabel(this.heightLabel);

        this.updateLabelsPosition();
    };

    private createLabel = (group: paper.Group) => {
        const rect = new this.manager.paper.Path.Rectangle(new this.manager.paper.Rectangle(0, 0, 70, 24), new this.manager.paper.Size(4, 4));
        rect.fillColor = new this.manager.paper.Color('#ffffff');
        rect.strokeScaling = false;
        rect.strokeWidth = 0.5;
        rect.strokeColor = new this.manager.paper.Color('#9ca3af');

        const text = new this.manager.paper.PointText(new this.manager.paper.Point(35, 16));
        text.content = '100 cm';
        text.fontSize = 11;
        text.fontWeight = 400;
        text.fontFamily = 'Inter, Montserrat, sans-serif';
        text.fillColor = new this.manager.paper.Color('#455a64');
        text.justification = 'center';

        group.addChildren([rect, text]);
    };

    private updateLabelsText = (item: paper.Item) => {
        if (item) {
            (this.widthLabel.children[1] as paper.PointText).content =
                (item.bounds.width / this.manager.ppcm / this.manager.unit.ratio).toFixed(3) + ' ' + this.manager.unit.value;
            (this.heightLabel.children[1] as paper.PointText).content =
                (item.bounds.height / this.manager.ppcm / this.manager.unit.ratio).toFixed(3) + ' ' + this.manager.unit.value;

            // Scale the label rectangle to fit the label size
            let scaleRatio = (this.widthLabel.children[1].bounds.width + 20) / this.widthLabel.children[0].bounds.width;
            this.widthLabel.children[0].scale(scaleRatio, 1);

            scaleRatio = (this.heightLabel.children[1].bounds.width + 20) / this.heightLabel.children[0].bounds.width;
            this.heightLabel.children[0].scale(scaleRatio, 1);
        } else {
            throw new Error('Item cannot be null');
        }
    };

    public updateLabelsPosition = () => {
        if (this.manager.selectedItem) {
            const scale = 1 / this.manager.paper.view.zoom;
            this.widthLabel.scaling = new this.manager.paper.Point(scale, scale);
            this.heightLabel.scaling = new this.manager.paper.Point(scale, scale);

            /*
            this.widthLabel.position = this.manager.selectedItem.bounds.topCenter.add(new this.manager.paper.Point(0, -20 / this.manager.paper.view.zoom));
            this.heightLabel.position = this.manager.selectedItem.bounds.leftCenter.add(
                new this.manager.paper.Point(-(20 + this.heightLabel.children[0].bounds.width / 2) / this.manager.paper.view.zoom, 0)
            );*/

            // Recupero i bordi della vista (camera) e imposto un margine di sicurezza
            const viewBounds = this.manager.paper.view.bounds;
            const margin = 20 * scale;
 
            // ---------------------------------------------------------
            // 1. GESTIONE WIDTH LABEL (Etichetta orizzontale - Top/Bottom)
            // ---------------------------------------------------------
            const topOffset = 40 / this.manager.paper.view.zoom;
            // Posizione default: SOPRA
            let widthLabelPosition = this.manager.selectedItem.bounds.topCenter.subtract(new this.manager.paper.Point(0, topOffset));

            // Se tocca il soffitto (Top), flippa SOTTO (dentro)
            if (widthLabelPosition.y < viewBounds.top + margin) {
                widthLabelPosition = this.manager.selectedItem.bounds.topCenter.add(new this.manager.paper.Point(0, topOffset));
            }
            this.widthLabel.position = widthLabelPosition;

            // ---------------------------------------------------------
            // 2. GESTIONE HEIGHT LABEL (Etichetta verticale - Left/Right)
            // ---------------------------------------------------------

            // Calcolo l'offset laterale (40px + metà della larghezza del testo)
            const sideOffsetVal = (40 + this.heightLabel.children[0].bounds.width / 2) / this.manager.paper.view.zoom;

            // Posizione default: SINISTRA
            let heightLabelPosition = this.manager.selectedItem.bounds.leftCenter.subtract(new this.manager.paper.Point(sideOffsetVal, 0));

            // Se tocca il bordo SINISTRO, flippa a DESTRA (dentro)
            if (heightLabelPosition.x < viewBounds.left + margin) {
                heightLabelPosition = this.manager.selectedItem.bounds.leftCenter.add(new this.manager.paper.Point(sideOffsetVal, 0));
            }

            // (Opzionale) Se dovesse toccare il bordo destro in futuro, basterebbe aggiungere un altro if qui

            this.heightLabel.position = heightLabelPosition;

            this.layer.visible = true;
        } else if (this.layer.visible) {
            this.layer.visible = false;
        }
    };

    public onViewZoomChanged = () => {
        this.updateLabelsPosition();
    };

    public onAreaSelectionChanged = (item: paper.Item, area: Area, selected: boolean) => {
        if (selected) {
            // Update text only for selected item, this event is triggered also for deselect
            this.updateLabelsText(item);
        }

        this.updateLabelsPosition();
    };

    public onUnitChange = () => {
        if (this.manager.selectedItem) this.updateLabelsText(this.manager.selectedItem);
    };

    public onAreaMoving = () => {
        this.updateLabelsPosition();
    };

    public onAreaRotateStart = () => {
        this.layer.visible = false;
    };

    public onAreaResizeStart = () => {
        this.layer.visible = false;
    };

    public onAreaResizeEnd = (item: paper.Item) => {
        this.updateLabelsPosition();
        this.updateLabelsText(item);
    };

    public onAreaRotateEnd = (item: paper.Item) => {
        this.updateLabelsPosition();
        this.updateLabelsText(item);
    };

    public onAreaRemoved = (item: paper.Item) => {
        this.updateLabelsPosition();
    };
}
